(() => {
  const normalize = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const search = root.querySelector('[data-vigneron-search]');
    const region = root.querySelector('[data-vigneron-region]');
    const count = root.querySelector('[data-vigneron-count]');
    const empty = root.querySelector('[data-vigneron-empty]');
    const list = root.querySelector('[data-vigneron-list]');
    const rows = [...root.querySelectorAll('[data-vigneron-row]')].sort((a, b) => a.dataset.name.localeCompare(b.dataset.name, 'fr'));
    rows.forEach(row => list.append(row));
    const regions = [...new Set(rows.flatMap(row => row.dataset.region.split(' · ').filter(Boolean)))].sort((a,b) => a.localeCompare(b,'fr'));
    regions.forEach((name, i) => { const option = document.createElement('option'); option.value = name; option.textContent = name; region.append(option); });
    function filter() {
      const query = normalize(search.value); let n = 0;
      rows.forEach(row => { row.hidden = !(normalize(row.dataset.search).includes(query) && (!region.value || row.dataset.region.split(' · ').includes(region.value))); if (!row.hidden) n++; });
      count.textContent = n + ' ' + (n === 1 ? root.dataset.countOne : root.dataset.countMany);
      empty.hidden = n > 0;
    }
    search.addEventListener('input', filter); region.addEventListener('change', filter);
    root.querySelector('[data-vigneron-tools]').hidden = false; filter();
  }
  document.querySelectorAll('[data-vigneron-directory]').forEach(init);
  document.addEventListener('shopify:section:load', event => { event.target.querySelectorAll('[data-vigneron-directory]').forEach(init); });
})();
